import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { asTextData } from '@angular/core/src/view';
import { CustomValidatorService } from "../../../services/common/custom-validator.service"
import { IdentifierService } from 'src/app/services/identifier.service';

@Component({
  selector: 'app-popup-new-identifier',
  templateUrl: './popup-new-identifier.component.html',
  styleUrls: ['./popup-new-identifier.component.scss']
})
export class PopupNewIdentifierComponent implements OnInit {

  @Input() data: any;
  identifierType;
  identifierValue;
  check: false;
  identifiersInfo;
  identifierErrorType;
  showError = false;
  showValidationError = false;
  listOfIdentifier=[];


  constructor(
    private route: Router, private identifierService:IdentifierService
  ) { }

  ngOnInit() {
    let self = this;
    let option = {
      type: 'get',
      url: 'bankIdentifier',
      includeUserSession: true,
      isDeveloper: true,
      pathVariables:[this.data.body]
      
    }
    this.identifierService.getData(option,function(data){
      self.listOfIdentifier=data;
    })
  }

  onIdentifierTypeSelect(event) {
    this.identifierErrorType = event.target.options[event.target.selectedIndex].getAttribute("name");
    this.identifierType = event.target.value.toLowerCase();
    this.showValidationError = false;
    this.identifierValue = "";
    this.setErrorState(false);
  }

  setErrorState(boolean) {
    this.showError = boolean
  }

  closePopup() {
    this.data.popupComponentClose();

    if(this.data.cancelCallback) {
      this.data.cancelCallback();
    }
  }

  getvalidations() {
    console.log('identifierType ===============  ', this.identifierType);
    switch (this.identifierType) {
      case "aadhar": {
        if(CustomValidatorService.validateAadhar(this.identifierValue)){
          return true;
        }
        else{
          this.showValidationError = true;
        }
      }
      break;
      case "mobile": {
        if(CustomValidatorService.validateMobileInPopup(this.identifierValue)){
          return true;
        }
        else{
          this.showValidationError = true;
        }
      }
      break;
      case "pan": {
        if(CustomValidatorService.validatePan(this.identifierValue)){
          return true;
        }
        else{
          this.showValidationError = true;
        }
      }
      break;
      case "crn": {
        if(CustomValidatorService.validateCRN(this.identifierValue)){
          return true;
        }
        else{
          this.showValidationError = true;
        }
      }
      break;
      case "accno": {
        //validateAccountNumber
        if(CustomValidatorService.validateAccountNumber(this.identifierValue)){
          return true;
        }
        else{
          this.showValidationError = true;
        }
          
      }
      break;
    }
  }

  confirm() {
    let status = this.getvalidations();
    console.log(status);
    if(!this.getvalidations()){
      this.showValidationError = true;
      return;
    }
    if(!this.identifierType || !this.identifierValue) {
      this.setErrorState(true);
      return;
    }
    this.identifiersInfo = {
      "type"      : this.identifierType,
      "value"     : this.identifierValue,
      "category"  : "strong",
      "check"     : this.check,
    }
    this.data.successCallback(this.identifiersInfo);
  }

}
